export default __webpack_public_path__ + "img/appstore.e09e3bb9.png";